import { connect } from 'react-redux'

import PriceLabel from './PriceLabel'

const mapStateToProps = ({ onlyCash: isOnlyCash, catalog }) => {
  const {
    currencyConfiguration: {
      pointsName: name,
      decimalPlaces
    }
  } = catalog
  return ({
    isOnlyCash,
    currency: {
      name,
      decimalPlaces
    }
  })
}

export default connect(mapStateToProps)(PriceLabel)



// WEBPACK FOOTER //
// ./src/Catalog/Availability/PriceLabel/PriceLabelContainer.js